/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontOnly_item = {
    readonly isStorefrontOnly: boolean | null;
    readonly " $refType": "StorefrontOnly_item";
};
export type StorefrontOnly_item$data = StorefrontOnly_item;
export type StorefrontOnly_item$key = {
    readonly " $data"?: StorefrontOnly_item$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontOnly_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontOnly_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isStorefrontOnly",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'bd19f05b83da40587f7adf343ba3b6ff';
export default node;
